export enum PersonTypeEnum {
  ADT = 'ADT',
  CHD_A = 'CHD_A',
  CHD_B = 'CHD_B',
  BB = 'BB',
}
